import DailyAbsenceForm from './DailyAbsenceForm';

import { AbsenceFormProps } from './AbsenceFormProps';
import React, { useMemo } from 'react';
import { useExtraFieldsFormValidationByFormId7 } from '../ExtraFields/useExtraFieldsFormValidation7';
import { FieldType } from 'server/src/apps/internal-shared/repositoriesShared/EmployeeDataRepositoryBase';
import {
  extraFieldsContextParams,
  ExtraFieldsFormId,
  ExtraFieldsSupportedObject,
} from '../ExtraFields/types';
import Loading from './Loading';
import { createDailyAbsenceValidationSchema } from './validationSchema';

const validationSchema = createDailyAbsenceValidationSchema();

export const DailyAbsenceFormWithExtraFields: React.FC<
  React.PropsWithChildren<AbsenceFormProps>
> = (props) => {
  const { applyExtraFieldsValidationSchema, loading } =
    useExtraFieldsFormValidationByFormId7({
      objectApiName: ExtraFieldsSupportedObject.Absence,
      formId: ExtraFieldsFormId.AbsencesRequestAbsence,
      contextParams: [
        {
          name: extraFieldsContextParams.absenceRequestForm.absenceCategoryName,
          type: FieldType.String,
          value: props.categoryName,
        },
      ],
    });

  const validationSchemaWithExtraFields = useMemo(() => {
    return applyExtraFieldsValidationSchema(validationSchema);
  }, [applyExtraFieldsValidationSchema]);

  if (loading) {
    return (
      <Loading
        absenceCategoriesGroupSelect={props.absenceCategoriesGroupSelect}
        absenceCategorySelect={props.absenceCategorySelect}
      />
    );
  }
  // it is super important to never change validationSchemaWithExtraFields property, otherwise validation is broken
  return (
    <DailyAbsenceForm
      {...props}
      validationSchema={validationSchemaWithExtraFields}
    />
  );
};
